// /src/store/mediaManagment/reducer.ts

import {
  FETCH_MEDIA_REQUEST,
  FETCH_MEDIA_SUCCESS,
  FETCH_MEDIA_FAILURE,
  FETCH_MEDIA_BY_ID_REQUEST,
  FETCH_MEDIA_BY_ID_SUCCESS,
  FETCH_MEDIA_BY_ID_FAILURE,
  FETCH_MEDIA_BY_TYPE_REQUEST,
  FETCH_MEDIA_BY_TYPE_SUCCESS,
  FETCH_MEDIA_BY_TYPE_FAILURE,
  MediaState,
  initialState,
  MediaActionTypes
} from './types';

const mediaListReducer = (state = initialState, action: MediaActionTypes): MediaState => {
  switch (action.type) {
    case FETCH_MEDIA_REQUEST:
    case FETCH_MEDIA_BY_ID_REQUEST:
    case FETCH_MEDIA_BY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MEDIA_SUCCESS: {
      const mediaMap = new Map(state.medias);
      action.payload.medias.forEach(media => {
        mediaMap.set(media.id, media);
      });
      return {
        ...state,
        loading: false,
        medias: mediaMap,
        lastFetchTimestamp: action.payload.lastFetchTimestamp,
        lastFetchParams: action.payload.lastFetchParams
      };
    }

    case FETCH_MEDIA_BY_ID_SUCCESS:
    case FETCH_MEDIA_BY_TYPE_SUCCESS: {
      const mediaMap = new Map(state.medias);
      if (Array.isArray(action.payload)) {
        action.payload.forEach(media => {
          mediaMap.set(media.id, media);
        });
      } else {
        mediaMap.set(action.payload.id, action.payload);
      }
      return {
        ...state,
        loading: false,
        medias: mediaMap,
        lastFetchTimestamp: Date.now()
      };
    }

    case FETCH_MEDIA_FAILURE:
    case FETCH_MEDIA_BY_ID_FAILURE:
    case FETCH_MEDIA_BY_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default mediaListReducer;
